import { useEffect, useState } from 'react';
import { Site } from './site/Site';
import { Make } from './make/Make';
import { log } from './lib/log';

export function routeFrom(pathname: string): 'make' | 'site' {
  return pathname.replace(/\/+$/, '').endsWith('/make') ? 'make' : 'site';
}

export function navigate(path: string): void {
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function Router() {
  const [route, setRoute] = useState(() => routeFrom(window.location.pathname));

  useEffect(() => {
    const onPop = () => setRoute(routeFrom(window.location.pathname));
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = route === 'make' ? 'steamed · what I can make' : 'steamed';
    log.info('app', `route ${route}`);
  }, [route]);

  return route === 'make' ? <Make /> : <Site />;
}
